import strings from '../../Localization/Localization';

import {
  getAlphalinkPlaces,
  createAlphalinkPlace
} from '../../API/AlphalinkMVNO';

import {
  FLASHBAG_TYPE_SUCCESS,
  FLASHBAG_TYPE_DANGER
} from '../../Store/Action/flashbag';

let alphalinkId = {
  fieldKey: "alphalink_id",
  type: "dropdownEntity",
  label: strings.form.alphalinkPlace.alphalinkId.label,

  validators: [],
  assertObjectDefaultValue: true,

  loader: {
    id: "alphalinkPlaces",
    loader: getAlphalinkPlaces,
    loaderRequire: (value, getValues) => {
      const values = getValues();
      return values && values.partner && values.partner["alphalink_client_account"] && values.partner["alphalink_client_account"]["alphalink_id"];
    },
    loaderArguments: (value, getValues) => {
      const values = getValues();
      return [values.partner["alphalink_client_account"]["alphalink_id"]];
    },
    dataTransformation: (response) => response.data
  },

  adapter: {
    requirement: (data) => data["idcustomer_site"] && data["customer_site"],
    getValue: (data) => data["idcustomer_site"],
    getLabel: (data) => `${data["idcustomer_site"]} - ${data["customer_site"]}`
  },
}

let alphalinkPlaceCreation = {
  fieldKey: "alphalink_place_creation",
  type: "button",
  label: strings.form.alphalinkPlace.alphalinkPlaceCreation.label,

  showOnDisabled: () => false,
  disabled: (getValues) => {
    if(!!(getValues(0)["alphalink_id"])) {
      return true;
    }
    return false;
  },

  as: 'request',
  request: {
    request: createAlphalinkPlace,
    requestRequire: () => true,
    requestArguments: (getValues) => [getValues().id],
    postRequestCallback: [
      {
        type: "flashbag",
        message: strings.form.alphalinkPlace.alphalinkPlaceCreation.flashbagMessage,
        flashbagType: FLASHBAG_TYPE_SUCCESS,
      },
      {
        type: "reload"
      }
    ],
    postRequestCallbackFailure: [
      {
        type: "flashbag",
        message: strings.form.alphalinkPlace.alphalinkPlaceCreation.flashbagMessageFailure,
        flashbagType: FLASHBAG_TYPE_DANGER,
      }
    ],
  },
}

export const form = {
  formKey: "alphalinkPlace",
  fields: [
    alphalinkId,
    alphalinkPlaceCreation
  ]
}
